import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';
import { FindingAiService } from '../api/agentStep.model';
import { getAiServiceLogoPath, getAiServiceDisplayName } from 'src/app/common/aiServiceUtils';

export const AIDR_SUPPORTED_SERVICES: FindingAiService[] = [
  FindingAiService.agentforce,
  FindingAiService.azureAiFoundry,
  FindingAiService.chatGptEnterprise,
  FindingAiService.openaiCodex,
  FindingAiService.copilotStudio,
  FindingAiService.customAgent,
  FindingAiService.m365Copilot,
  FindingAiService.serviceNow,
  FindingAiService.vertexAi,
  FindingAiService.bedrockAgentCore,
];

export const FindingAiServiceSelectOptions: ISelectOption[] = AIDR_SUPPORTED_SERVICES.map((service) => ({
  id: `${FilterTypesEnum.AiService}-${service}`,
  value: service,
  displayName: getAiServiceDisplayName(service),
  filterType: FilterTypesEnum.AiService,
  categoryName: FilterTypesEnum.AiService.toString(),
  iconPath: getAiServiceLogoPath(service),
  withoutBeautifyDisplayName: true,
})).sort((a, b) => a.displayName.localeCompare(b.displayName)); // Alphabetical order
